import { FIELD_TYPES } from "constants/template-field-type";
import ContactSalesHubspotFormConfig from "../side-by-side-hubspot-form/components/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Hubspot Dynamic Form",
  fields: {
    formId: {
      type: FIELD_TYPES.TEXT,
      label: "Form ID"
    },
    ...ContactSalesHubspotFormConfig
  }
};
